import { useHasAnyQuery } from '../promotionsApi';

export function useShowNewPromoAlert(type: string): boolean {
  const { data: hasAny, isLoading, isError } = useHasAnyQuery({ type });
  return !isLoading && !isError && hasAny === false;
}
